import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/e-signature-requests/{eSignatureRequestId}']['PUT'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const updateESignatureRequest = async ({ eSignatureRequestId, ...body }: Input): Promise<Output> => {
  const response = await noodleApiClient.put(`/e-signature-requests/${eSignatureRequestId}`, body);
  return response.data;
};

export default updateESignatureRequest;
